import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ConvertHelper } from '@barthauer/abc/core';
import {
  ObjectKey,
  PersistenceService,
  PersistMode,
  PersistObjectModel,
  TargetColumnValue,
  TargetObjectData,
} from '@barthauer/abc/core/data';
import {
  AbcAccordionComponent,
  AbcHtmlEditorComponent,
  AbcNumberBoxComponent,
  AbcPopupComponent,
  AbcTextBoxComponent,
  _AbcButtonComponent,
  _AbcCheckBoxComponent,
  _AbcSelectBoxComponent,
  _AbcTextAreaComponent,
} from '@barthauer/abc/ui-components';
import { MeasureProgress } from '@barthauer/custom/xmt-models';
import {
  DxButtonModule,
  DxCheckBoxModule,
  DxNumberBoxModule,
  DxSelectBoxModule,
  DxTextBoxModule,
} from 'devextreme-angular';
import { forkJoin, Observable, Subscription } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { NotificationMessage, ROLES, ToastType } from '../../../../models/enumeration-list.model';
import { AppService } from '../../../../services/app.service';
import { DataService, ObjectKeys } from '../../../../services/data.service';
import { NotificationService } from '../../../../services/notification.service';
import { SharedModule } from '../../../../shared/shared.module';
import { MeasureService } from '../../measure.service';
@Component({
  selector: 'ubt-geods-status-report',
  templateUrl: './status-report.component.html',
  styleUrls: ['./status-report.component.scss'],
  standalone: true,
  imports: [
    DxTextBoxModule,
    CommonModule,
    AbcPopupComponent,
    AbcAccordionComponent,
    DxSelectBoxModule,
    AbcTextBoxComponent,
    DxNumberBoxModule,
    AbcNumberBoxComponent,
    _AbcSelectBoxComponent,
    _AbcButtonComponent,
    DxButtonModule,
    SharedModule,
    _AbcTextAreaComponent,
    _AbcCheckBoxComponent,
    DxCheckBoxModule,
    AbcHtmlEditorComponent,
  ],
})
export class StatusReportComponent implements OnDestroy, OnInit {
  @ViewChild('progressField') progressField: AbcNumberBoxComponent;
  @ViewChild('confirmDeletePopup') confirmDeletePopup: AbcPopupComponent;
  @Input() lastMeasureProgress: MeasureProgress;
  @Input() measureProgress: MeasureProgress[];
  @Input() measureId: string;
  @Output() assignReportToMeasure: EventEmitter<string> = new EventEmitter();
  @Output() updateReportData: EventEmitter<MeasureProgress> = new EventEmitter();
  @Output() deleteReport: EventEmitter<string> = new EventEmitter();
  public convertHelper = ConvertHelper;
  public workOnLastStatus = false;
  public isNewMeasureTask = false;
  public date = new Date();
  public disableSave: boolean = true;
  private originalReportData: MeasureProgress;
  private subscriptions: Subscription[] = [];
  toogleTitleVisible: boolean = false;
  public propertyName: string;
  @ViewChild('htmlEditor') htmlEditor: AbcHtmlEditorComponent;
  public fieldValue: string;
  @Input() canManageStatusReport: boolean;
  currentDescriptionField = '';
  constructor(
    public measureService: MeasureService,
    public dataService: DataService,
    private persistenceService: PersistenceService,
    public appService: AppService,
    private notificationService: NotificationService,
    private cdr: ChangeDetectorRef
  ) { }
  ngOnInit(): void {
    if (this.measureProgress && this.measureProgress?.length > 0) {
      this.measureProgress = this.measureProgress.map((measureprogress) => ({
        ...measureprogress,
        Progress: this.appService.sanitizeContent(measureprogress.Progress),
        NextSteps: this.appService.sanitizeContent(measureprogress.NextSteps),
        Decision: this.appService.sanitizeContent(measureprogress.Decision),
        RiskAndChance: this.appService.sanitizeContent(measureprogress.RiskAndChance),
      }));

      this.navigateToMeasureProgress(-1);
    }
    this.subscriptions.push(
      this.measureService.newStatusReport$.subscribe((status) => {
        this.isNewMeasureTask = status;


      })
    );
  }

  public navigateToMeasureProgress = (index: number): void => {
    this.appService.currentMeasureProgressIndex = this.appService.currentMeasureProgressIndex + index;
    this.lastMeasureProgress = this.measureProgress[this.appService.currentMeasureProgressIndex];
    this.originalReportData = new MeasureProgress({ ...this.lastMeasureProgress });
  };

  public persistStatusReport(): void {
    if (!this.lastMeasureProgress.Id) {
      this.addStatusReport();
    } else {
      this.updateStatusReport();
    }
  }

  public verifyChanges(event, propertyField: string, fieldName?: string): void {
    if (event.event) {
      if (event.event.originalEvent.type === 'paste') {
        const sanitizedContent = this.appService.sanitizeContent(propertyField, true);
        this.lastMeasureProgress[fieldName] = sanitizedContent;
        this.currentDescriptionField = this.lastMeasureProgress[fieldName];
        this.htmlEditor.value = sanitizedContent;
      } else {
        this.currentDescriptionField = propertyField;
      }

      if (event.value != undefined) {
        if (!this.originalReportData) {
          this.originalReportData = new MeasureProgress({ ...this.lastMeasureProgress });
          this.originalReportData[fieldName] = event.previousValue;
        }

        if (fieldName === 'ProgressPercentage') {
          this.measureService.validateNumberField(this.progressField, 0, 100);
        }
        if (this.originalReportData[fieldName] !== event.value) {
          this.disableSave = false;
        } else {
          this.disableSave =
            this.originalReportData.Progress == this.lastMeasureProgress.Progress &&
            this.originalReportData.NextSteps == this.lastMeasureProgress.NextSteps &&
            this.originalReportData.RiskAndChance == this.lastMeasureProgress.RiskAndChance &&
            this.originalReportData.Decision == this.lastMeasureProgress.Decision &&
            this.originalReportData.ProgressPercentage == this.lastMeasureProgress.ProgressPercentage &&
            this.originalReportData.MaturityLevel == this.lastMeasureProgress.MaturityLevel;
        }
      }
    } else {
      this.currentDescriptionField = propertyField;
    }
  }

  public addStatusReport = () => {
    const reportPersistQuery: TargetObjectData = new TargetObjectData();
    reportPersistQuery.ObjectKey = new ObjectKey();
    reportPersistQuery.Mode = PersistMode.Insert;
    reportPersistQuery.ObjectKey.ObjectType = ObjectKeys.MEASUREPROGRESS;
    const progressDate = new Date();

    const reportColumns: TargetColumnValue[] = [
      { Name: 'ParentId', Value: this.measureService.currentMeasureId },
      { Name: 'Progress', Value: this.lastMeasureProgress.Progress },
      { Name: 'NextSteps', Value: this.lastMeasureProgress.NextSteps },
      { Name: 'RiskAndChance', Value: this.lastMeasureProgress.RiskAndChance },
      { Name: 'Decision', Value: this.lastMeasureProgress.Decision },
      { Name: 'ProgressPercentage', Value: this.lastMeasureProgress.ProgressPercentage },
      { Name: 'MaturityLevel', Value: this.lastMeasureProgress.MaturityLevel },
      { Name: 'ProgressDate', Value: progressDate.toDateString() },
      { Name: 'SysTimeInsert', Value: progressDate.getHours() + ':' + progressDate.getMinutes() },
    ];
    reportPersistQuery.TargetColumns = reportColumns;
    const query: PersistObjectModel = new PersistObjectModel();
    query.Object = reportPersistQuery;
    this.subscriptions.push(
      forkJoin([
        this.persistenceService.executePersistObjectQuery(query).pipe(
          switchMap((result) => {
            return this.measureService.persistProperty(result['Id'], sessionStorage.getItem('currentProfile')).pipe(
              map((resultProperty) => {
                return {
                  measureProgress: result,
                  resultProperty,
                };
              })
            );
          })
        ),
        this.updateMaturityLevelMeasure(this.measureId, this.lastMeasureProgress.MaturityLevel),
      ]).subscribe((data: any) => {
        this.assignReportToMeasure.emit(data[0].measureProgress.Id);
        this.isNewMeasureTask = false;
        this.measureService.setNewSatusReport(false)
        this.appService.currentMeasureProgressIndex += 1;
        this.lastMeasureProgress.Id = data[0].measureProgress.Id;
        this.disableSave = true;
      })
    );
  };

  public updateStatusReport() {
    const reportPersistQuery: TargetObjectData = new TargetObjectData();
    reportPersistQuery.ObjectKey = new ObjectKey();
    reportPersistQuery.ObjectKey.ObjectType = ObjectKeys.MEASUREPROGRESS;
    reportPersistQuery.Mode = PersistMode.Update;
    reportPersistQuery.ObjectKey.Id = this.lastMeasureProgress.Id;
    const updateReportColumns: TargetColumnValue[] = [
      { Name: 'Progress', Value: this.lastMeasureProgress.Progress },
      { Name: 'NextSteps', Value: this.lastMeasureProgress.NextSteps },
      { Name: 'RiskAndChance', Value: this.lastMeasureProgress.RiskAndChance },
      { Name: 'Decision', Value: this.lastMeasureProgress.Decision },
      { Name: 'ProgressPercentage', Value: this.lastMeasureProgress.ProgressPercentage },
      { Name: 'MaturityLevel', Value: this.lastMeasureProgress.MaturityLevel },
    ];
    reportPersistQuery.TargetColumns = updateReportColumns;
    const query: PersistObjectModel = new PersistObjectModel();
    query.Object = reportPersistQuery;
    this.subscriptions.push(
      forkJoin([
        this.persistenceService.executePersistObjectQuery(query),
        this.updateMaturityLevelMeasure(this.measureId, this.lastMeasureProgress.MaturityLevel),
      ]).subscribe(
        () => {
          this.updateReportData.emit(this.lastMeasureProgress);
          this.notificationService.callNotification({
            message: NotificationMessage.ValidUpdateMessage,
            type: ToastType.SUCCESS,
          });
          this.disableSave = true;
          this.measureService.setNewSatusReport(false)

        },
        (error) => {
          this.notificationService.callNotification({ message: NotificationMessage.Error, type: ToastType.ERROR });
          console.error(error);
        }
      )
    );
  }

  private updateMaturityLevelMeasure(id: any, maturityLevel: any): Observable<any> {
    const measurePersistQuery: TargetObjectData = new TargetObjectData();
    measurePersistQuery.ObjectKey = new ObjectKey();
    measurePersistQuery.ObjectKey.ObjectType = ObjectKeys.MEASURE;
    measurePersistQuery.Mode = PersistMode.Update;
    measurePersistQuery.ObjectKey.Id = id;
    const updateReportColumns: TargetColumnValue[] = [{ Name: 'CurrentGrade', Value: maturityLevel }];
    measurePersistQuery.TargetColumns = updateReportColumns;
    const query: PersistObjectModel = new PersistObjectModel();
    query.Object = measurePersistQuery;
    return this.persistenceService.executePersistObjectQuery(query);
  }
  public clearProgressFileds = (): void => {
    if (this.workOnLastStatus == false) {
      this.lastMeasureProgress = {
        ...new MeasureProgress(null),
        ProgressDate: this.lastMeasureProgress.ProgressDate,
      };
      this.originalReportData = null;
    } else {
      this.lastMeasureProgress = { ...this.lastMeasureProgress };
      delete this.lastMeasureProgress['meta'];
      delete this.lastMeasureProgress.Id;
    }
    this.disableSave = false;
    this.isNewMeasureTask = true;
    this.measureService.setNewSatusReport(true)

  };

  public openConfirmTaskDialog(): void {
    this.confirmDeletePopup.instance.show();
  }

  public abortTaskDelete(): void {
    this.confirmDeletePopup.instance.hide();
  }

  public deleteStatusReport(): void {
    this.subscriptions.push(
      this.dataService.deleteObject(ObjectKeys.MEASUREPROGRESS, this.lastMeasureProgress.Id).subscribe(
        () => {
          this.deleteReport.emit(this.lastMeasureProgress.Id);
          this.confirmDeletePopup.instance.hide();
          if (this.measureProgress.length == 1) {
            this.lastMeasureProgress = this.measureProgress[0];
            this.originalReportData = new MeasureProgress({ ...this.lastMeasureProgress });
          } else if (this.measureProgress.length == 0) {
            this.appService.currentMeasureProgressIndex -= 1;
            this.lastMeasureProgress = new MeasureProgress(null);
            this.originalReportData = null;
            this.lastMeasureProgress.ProgressDate = new Date();
          } else if (this.measureProgress[this.appService.currentMeasureProgressIndex + 1]) {
            this.navigateToMeasureProgress(0);
          } else if (this.measureProgress[this.appService.currentMeasureProgressIndex - 1]) {
            this.navigateToMeasureProgress(-1);
          }
          this.notificationService.callNotification({
            message: NotificationMessage.ValidDeleteMessage,
            type: ToastType.SUCCESS,
          });
        },
        (error) => {
          console.error(error);
          this.notificationService.callNotification({ message: NotificationMessage.Error, type: ToastType.ERROR });
        }
      )
    );
  }
  public IsRoleAuthorizedToUpdateDate(): boolean {

    if (this.measureProgress && this.measureProgress?.length > 0) {
      if (this.isNewMeasureTask) {
        return !this.canManageStatusReport
      }
      else { return this.dataService.hasNonAuthrisedRole([ROLES.Admin]); }
    }

    else if (!this.isNewMeasureTask && this.dataService.hasNonAuthrisedRole([ROLES.Admin])) {
      return !this.canManageStatusReport
    }
    return !this.canManageStatusReport

  }

  public ngOnDestroy(): void {
    this.subscriptions.map((subscription) => subscription.unsubscribe());
  }

  public openPopup(fieldValue: string, propertyName: string): void {
    this.propertyName = propertyName;
    this.htmlEditor.value = fieldValue;
    this.toogleTitleVisible = true;
    this.cdr.markForCheck();
  }

  focusIn(fieldValue: string) {
    this.currentDescriptionField = fieldValue;
  }

  saveChanges(propertyName: string, fieldValue: any) {
    this.lastMeasureProgress[propertyName] = fieldValue;
    this.measureService.updateMeasure(propertyName, fieldValue, true);
    this.toogleTitleVisible = false;
  }
}
